"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var resource_1 = require("./Allianz/resource");
var resource_2 = require("./Flow/resource");
var resourcesHelper = {
    'Allianz': resource_1.default,
    'Flow': resource_2.default
};
var themeResource = ((_a = process.env.REACT_APP_THEME) === null || _a === void 0 ? void 0 : _a.toString()) || "Allianz";
exports.default = resourcesHelper[themeResource];
//# sourceMappingURL=resourcesLoader.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/resources/resourcesLoader.js
// module id = 2525
// module chunks = 0